import React from 'react';
import UserStore from '../../../stores/UserStore';
import AdjustAllotment from './AdjustAllotment.react';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';

const MAX = 'max';
const CURRENT = 'current';

export default class AllotmentInformation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            adjustType: null,
            clearType: null,
            showAdjustCycle: false
        }

        this.update = this.update.bind(this);
        this.clear = this.clear.bind(this);
    }

    update(type) {
        this.setState({ adjustType: type });
    }

    clear(type) {
        var url = GuestEndPoints.CLEAR_CURRENT_ALLOTMENT;
        if(type === MAX) {
            url = GuestEndPoints.CLEAR_MAX_ALLOTMENT;
        }

        AjaxPromises.POST(url, UserStore.getApiData({
            PatientId: this.props.guest.Guest_id
        })).then((resp) => {
            if(resp.Result) {
                GuestActions.loadFullGuest(this.props.guest.Guest_id);
                NotificationActions.addNotification({ type : 'success', body : 'Allotment Cleared' });
            }
            else {
                NotificationActions.addNotification({ type : 'error', body : 'Error Clearing Allotment' });
            }
        })
    }

    render() {
        var selectedLocation = this.props.location;
        var guest = this.props.guest;
        var data = this.props.data;
        var showAllotmentValidDate = selectedLocation.ShowAllotmentValidDates;     
        var showAdjustAllotment = !!this.state.adjustType;   

        return (
        <div>
            {
            (data.MaxLimit !== null) &&
            <div className='row'>
                <div className='col-6'>
                    Max Allotment
                </div>
                <div className='col-6'>
                {data.AllowOverrides ? [
                    <span onClick={() => this.update(MAX)} style={{ cursor:'pointer'}}>
                        {data.MaxLimit}g (Adjust)
                    </span>,                    
                    data.MaxAllotmentOverriden &&
                    <span onClick={() => this.clear(MAX)} style={{ marginLeft: 5, cursor: 'pointer'}}>
                        (Clear Override)
                    </span>
                    ] :
                    <span>{data.MaxLimit}g</span>
                }
                </div>
            </div>
            }
            <div className='row'>
                <div className='col-6'>
                    Current Allotment
                </div>
                <div className='col-6'>
                    {data.AllowOverrides ? [
                    <span onClick={() => this.update(CURRENT)} style={{ cursor:'pointer'}}>
                        {data.CurrentLimit}g (Adjust)
                    </span>,
                    data.CurrentAllotmentOverriden &&
                    <span onClick={() => this.clear(CURRENT)} style={{ marginLeft: 5, cursor: 'pointer'}}>
                        (Clear Override)
                    </span>] :
                    <span>{data.CurrentAllotmentOverriden ? data.CurrentLimitOverride : data.CurrentLimit}g</span>
                    }
                </div>
            </div>
            {
            showAllotmentValidDate && [
            <div className='row'>
                <div className='col-6'>
                    Allotment Valid From
                </div>
                <div className='col-6'>
                    {data.ValidFrom ? moment(data.ValidFrom).format('MM/DD/YYYY') : '-'}
                </div>
            </div>,
            <div className='row'>
                <div className='col-6'>
                    Allotment Valid Until
                </div>
                <div className='col-6'>
                    {data.ValidUntil ? moment(data.ValidUntil).format('MM/DD/YYYY') : '-'}
                </div>
            </div>
            ]}
            {
            data.ShowCycleData &&
            <div className='row'>
                <div className='col-6'>
                    Cycle Date
                </div>
                <div className='col-6'>
                    {data.CycleDate ? moment(data.CycleDate).format('MM/DD/YYYY') : '-'}
                </div>
            </div>
            }
            {
                showAdjustAllotment &&
                <AdjustAllotment 
                    guest={guest}
                    current={this.state.adjustType === MAX ? data.MaxLimit : data.CurrentLimit}
                    type={this.state.adjustType}
                    onClose={() => this.setState({ adjustType: null })}
                />
            }
        </div>);
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/AllotmentInformation.react.jsx